import { ValidationResult, ValidationError } from '../types/api.types';

// CUSIP Validation
export const validateCusip = (cusip: string): ValidationResult => {
    const errors: ValidationError[] = [];
    
    if (!cusip) {
        errors.push({ field: 'cusip', message: 'CUSIP is required' });
    } else if (!/^[A-Z0-9]{9}$/.test(cusip)) {
        errors.push({ field: 'cusip', message: 'CUSIP must be 9 alphanumeric characters' });
    }

    return {
        isValid: errors.length === 0,
        errors
    };
};

// Shareholder Validation
export const validateShareholder = (data: {
    cusip: string;
    accountNumber: string;
    email: string;
    firstName: string;
    lastName: string;
    noOfShares: number;
    recordDate?: string;
}): ValidationResult => {
    const errors: ValidationError[] = [];

    // CUSIP validation
    const cusipValidation = validateCusip(data.cusip);
    if (!cusipValidation.isValid) {
        errors.push(...cusipValidation.errors);
    }

    // Account Number validation
    if (!data.accountNumber) {
        errors.push({ field: 'accountNumber', message: 'Account number is required' });
    }

    // Email validation
    if (!data.email) {
        errors.push({ field: 'email', message: 'Email is required' });
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email)) {
        errors.push({ field: 'email', message: 'Invalid email format' });
    }

    // Name validation
    if (!data.firstName) {
        errors.push({ field: 'firstName', message: 'First name is required' });
    }
    if (!data.lastName) {
        errors.push({ field: 'lastName', message: 'Last name is required' });
    }

    // Shares validation
    if (!data.noOfShares) {
        errors.push({ field: 'noOfShares', message: 'Number of shares is required' });
    } else if (data.noOfShares < 0) {
        errors.push({ field: 'noOfShares', message: 'Number of shares must be positive' });
    }

    // Record Date validation (optional)
    if (data.recordDate && !/^\d{4}-\d{2}-\d{2}$/.test(data.recordDate)) {
        errors.push({ field: 'recordDate', message: 'Invalid date format (YYYY-MM-DD)' });
    }

    return {
        isValid: errors.length === 0,
        errors
    };
}; 

// Shareholder Validation
export const validateFtp = (data: {
    host: string;
    port: number;
    user: string;
    password: string;
    protocol: string;
}): ValidationResult => {
    const errors: ValidationError[] = [];

    // Host validation
    if (!data.host) {
        errors.push({ field: 'host', message: 'Host is required' });
    }

    // Port validation
    if (!data.port) {
        errors.push({ field: 'port', message: 'Port is required' });
    } else if (data.port < 1 || data.port > 65535) {
        errors.push({ field: 'port', message: 'Port must be between 1 and 65535' });
    }

    // User validation
    if (!data.user) {
        errors.push({ field: 'user', message: 'User is required' });
    }

    // Password validation
    if (!data.password) {
        errors.push({ field: 'password', message: 'Password is required' });
    }

    return {
        isValid: errors.length === 0,
        errors
    };
}; 